export default {
  registerForm: {
    title: '注册账号',
    registerSuccess: '注册成功',
    verification: {
      title: '请输入发送至 {email} 的验证码，验证后即可完成注册。',
      send: '验证码已发送',
      noReceived: '未收到验证码?',
      resend: '重新发送',
    },
    existAccount: '已有账号？',
    backLogin: '返回登录',
    previousStep: '上一步',
    validatePassword: '两次密码输入不一致',
    email: {
      placeholder: '请输入您的邮箱',
      registered: '邮箱已注册，请登录',
    },
    is_agree: {
      legal_agreement: '用户服务协议',
      privacyPolicy: '隐私政策',
      connectText: '和',
      checkPrompt: '请勾选保密隐私协议',
    },
    contact: {
      name: '联系人名字',
      pleaseInput: '请输入联系人',
      cell: '联系电话',
    },
    country: {
      placeholder: '国家或地区',
    },
    organization: {
      placeholder: '公司',
    },
    representative: {
      placeholder: '推荐人名字',
    },
    username: {
      placeholder: '账号名',
      pleaseInput: '请输入用户名',
      complianceCheck:
        '必须以字母开头,仅支持数字、字母、下划线,且长度在3-32个字符之间',
      alreadyExist: '用户名已存在',
    },
    password: {
      placeholder: '密码',
      pleaseInput: '请输入密码',
      specialCharacterCheck: '密码不能包含特殊字符',
      characterCheck: '密码必须为8-20位且包含英文大小写和数字',
    },
    repassword: {
      placeholder: '确认密码',
      pleaseInput: '请输入确认密码',
    },
    submitBtn: {
      register: '注册({currentForm}/4)',
      nextStep: '下一步({currentForm}/4)',
    },
  },
  registerSuccessRouteToPc:
    '为了您能更好的体验产品，请在PC端访问下方链接进行登录',
}
